/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Preview_Vehicle_Number_LabelInputs */

const fr_settings_preview_vehicle_number_label = /** @type {(inputs: Settings_Preview_Vehicle_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de véhicule`)
};

const en_settings_preview_vehicle_number_label = /** @type {(inputs: Settings_Preview_Vehicle_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle number`)
};

/**
* | output |
* | --- |
* | "Vehicle number" |
*
* @param {Settings_Preview_Vehicle_Number_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_preview_vehicle_number_label = /** @type {((inputs?: Settings_Preview_Vehicle_Number_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Preview_Vehicle_Number_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_preview_vehicle_number_label(inputs)
	return en_settings_preview_vehicle_number_label(inputs)
});